import { ReactNode } from "react";

import { useSelector } from "@src/store";
import { ExperienceBuilderSelector } from "@src/store/slices/experienceBuilder";

import { AuthenticatedNavigatorProvider } from "./AuthenticatedNavigatorProvider";
import { UnauthenticatedNavigatorProvider } from "./UnauthenticatedNavigatorProvider";

/**
 * Picks the navigator data source. When the builder previews the logged-in
 * org's own store we have a valid admin token (authenticated); a configured URL
 * override points it at a store the token can't reach, so we fall back to the
 * store's public Predictive Search Ajax API (unauthenticated). Selecting on
 * `isAuthenticated` (derived from the override) means clearing/setting the
 * override remounts the right provider automatically.
 */
export const NavigatorProvider = ({ children }: { children: ReactNode }) => {
  const isAuthenticated = useSelector(
    ExperienceBuilderSelector.isAuthenticated
  );

  return isAuthenticated ? (
    <AuthenticatedNavigatorProvider>{children}</AuthenticatedNavigatorProvider>
  ) : (
    <UnauthenticatedNavigatorProvider>
      {children}
    </UnauthenticatedNavigatorProvider>
  );
};
